import { render, staticRenderFns } from "./ModalDeleteVitalSign.vue?vue&type=template&id=d52737b0&scoped=true"
import script from "./ModalDeleteVitalSign.vue?vue&type=script&lang=js"
export * from "./ModalDeleteVitalSign.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteVitalSign.vue?vue&type=style&index=0&id=d52737b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52737b0",
  null
  
)

export default component.exports